import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img
              src="/assets/media/automat-logo.png"
              alt="Automat Logo" 
              className="h-10 w-auto mb-6"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="text-gray-400 mb-6 text-sm leading-relaxed">
              <p className="font-semibold text-white mb-2">{t('footer.address.title')}</p>
              <p>{t('footer.address.street')}</p>
              <p>{t('footer.address.zip')}</p>
              <p>{t('footer.address.city')}</p>
            </div>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/goautomat/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-purple-600 rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-xl text-white"></i>
              </a>
              <a href="https://www.instagram.com/goautomat/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-purple-600 rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-instagram-fill text-xl text-white"></i>
              </a>
              <a href="https://www.youtube.com/@goautomat" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-purple-600 rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-youtube-fill text-xl text-white"></i>
              </a>
            </div>
          </div>

          {/* Produto */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-lg">{t('footer.product.title')}</h4>
            <ul className="space-y-4">
              <li><a href="#recursos" className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer">{t('footer.product.features')}</a></li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-lg">{t('footer.company.title')}</h4>
            <ul className="space-y-4">
              <li><Link to="/sobre" className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer">{t('footer.company.about')}</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer">{t('footer.company.blog')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer">{t('footer.company.contact')}</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-lg">{t('footer.legal.title')}</h4>
            <ul className="space-y-4">
              <li><Link to="/privacidade" className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer">{t('footer.legal.privacy')}</Link></li>
              <li><Link to="/termos" className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer">{t('footer.legal.terms')}</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer">{t('footer.legal.security')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer">{t('footer.legal.lgpd')}</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <p className="text-gray-500 text-sm text-center">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
